module.exports = __webpack_public_path__ + "img/chenggong@2x.9ebc9c0f.png";